/* eslint-disable react/display-name */
import React, {useRef} from 'react';
import {Button, message, PageHeader, Popover, Tag, Typography} from 'antd';
import {Link} from 'react-router-dom';
import copy from 'copy-to-clipboard';

import {CopyOutlined, PlusOutlined} from '@/icons';
import {PageGrid, SecurityTextView} from '@/component';
import ClientAppFormModal from './ClientAppFormModal';
import {getClientAppPageUrl} from '@/api/clientApps';
import useTitle from '@/hook/useTitle';
import {useEditAuthService} from '@/page/admin/adminService';

export default function ClientAppsPage() {
    const editable = useEditAuthService(['global:sys_client_app:w']);
    useTitle('Api 群组 - 系统管理');

    const ClientAppFormModalRef = useRef();
    const PageGridRef = useRef();

    function onAddClick() {
        ClientAppFormModalRef.current.showModal();
    }

    function onCopyClick(text) {
        return () => {
            if (copy(text)) {
                message.success('拷贝成功');
            }
        };
    }

    function reload() {
        PageGridRef.current.reload2FirstPage();
    }

    const columns = [
        {
            dataIndex: 'name',
            title: 'Api 群组',
            render: (text, record) => {
                return <Link to={`/admin/clientapps/${record.id}`}>{text}</Link>;
            },
        },
        {
            dataIndex: 'accessCode',
            title: 'Access Code',
            render: text => (
                <>
                    <Typography.Text>{text}</Typography.Text>
                    <Button
                        type="text"
                        size="small"
                        icon={<CopyOutlined />}
                        onClick={onCopyClick(text)}
                    />
                </>
            ),
        },
        {
            dataIndex: 'accessSignKey',
            title: 'Access Sign Key',
            render: text => {
                const popoverContent = (
                    <>
                        <Typography.Paragraph strong underline>
                            {text}
                        </Typography.Paragraph>
                    </>
                );
                return (
                    <Popover title="Sign Key" content={popoverContent}>
                        <Button type="text" size="small">
                            <SecurityTextView text={text} showButton={false} />
                        </Button>
                        <Button
                            type="text"
                            size="small"
                            icon={<CopyOutlined />}
                            onClick={onCopyClick(text)}
                        />
                    </Popover>
                );
            },
        },
        {
            dataIndex: 'appName',
            title: '关联应用',
            render: text => {
                return text ? <Tag color="blue">{text}</Tag> : <Tag>未绑定应用</Tag>;
            },
        },
    ];

    const extra = (
        <Button type="primary" icon={<PlusOutlined />} onClick={onAddClick} disabled={!editable}>
            添加 Api 群组
        </Button>
    );

    return (
        <PageHeader title={`API 群组配置`} extra={extra} style={{overflowY: 'auto'}}>
            <PageGrid ref={PageGridRef} columns={columns} url={getClientAppPageUrl()} />
            <ClientAppFormModal ref={ClientAppFormModalRef} reload={reload} />
        </PageHeader>
    );
}
